export default {
  profile: 'Profile',
  settings: 'Settings',
};
